<template>
  <div class="container p-0 mt-2" v-show="!hidden">
    <div class="form-group" :class="{ 'was-validated': wasValidated }">
      <div class="form-check">
        <input
          :id="'legalCheckbox-' + element.name"
          class="form-check-input"
          type="checkbox"
          v-model="checked"
          :required="isRequired"
          @change="onChange"
        >
        <label
          class="form-check-label"
          :for="'legalCheckbox-' + element.name"
          :innerHTML="getTextFor(element.text, lang)"
        ></label>
        <div class="invalid-feedback">{{ getTextFor(element.invalid, lang) }}</div>
      </div>
      <div v-if="element.explanation" class="form-text">{{ getTextFor(element.explanation, lang) }}</div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'FormElementLegalCheckbox',
  props: ['element', 'lang', 'targetId', 'formData', 'wasValidated', 'hidden'],
  data() {
    return {
      checked: false,
    }
  },
  computed: {
    isRequired(): boolean {
      return !!this.element.required && !this.checked
    }
  },
  methods: {
    onChange() {
      this.$emit('elementChanged', this.element.name, this.checked)
    },
    getTextFor(data: any, lang: string) {
      return data ? data[lang] || '' : ''
    }
  },
  created() {
    const value = this.formData ? this.formData[this.element.name] : undefined
    this.checked = value === true
  }
}
</script>

<style scoped>
.form-check-input {
  border-color: #ced4da;
}

.was-validated .form-check-input:required:invalid {
  border-color: #dc3545;
}

.was-validated .form-check-input:required:valid {
  border-color: #198754;
}

.form-check-label :deep(a) {
  text-decoration: underline;
}
</style>
